import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { findIndex, get } from 'lodash';

import TableContext from './TableContext';
import styles from './Table.module.scss';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '~/v5/design-system/DropdownMenu.js';

const TableRowAdd = ({ groupId, isGroup }) => {
  const {
    isLoading,
    cellPadding,
    frozenColumns,
    visibleColumns,
    onRowAdd,
    onGroupAdd
  } = useContext(TableContext);

  const utilityColCount = findIndex(visibleColumns, col => col.index >= 0) || 0;
  const lastColumn = get(visibleColumns, utilityColCount + frozenColumns, {});
  const width = lastColumn.totalLeft;

  if (isLoading || !onRowAdd) {
    return null;
  }

  const handleClick = isGroup
    ? onGroupAdd
    : Array.isArray(onRowAdd)
      ? null
      : () => onRowAdd(groupId);

  const renderInner = () => (
    <div
      className={classnames(styles.Cell, {
        clickable: isGroup || (!isGroup && !Array.isArray(onRowAdd))
      })}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      <img
        className={styles.AddIcon + ' inline-block'}
        src="/images/icon_add_eggplant.svg"
        alt={`Add a new ${isGroup ? 'group' : 'item'}`}
      />
      <span className={styles.AddText}>New {isGroup ? 'group' : 'item'}</span>
    </div>
  );

  return (
    <div
      className={classnames(styles.Add, [
        {
          [styles.Row]: !isGroup,
          [styles.no_padding]: cellPadding === '0' || cellPadding === 0,
          [styles.S]: cellPadding === 'S',
          [styles.L]: cellPadding === 'L'
        }
      ])}
    >
      <div
        className={classnames(
          styles.AddWrapper,
          {
            [styles.Cell_sticky_last]: frozenColumns
          },
          'tailwind-root'
        )}
        style={frozenColumns ? { width } : null}
      >
        {!isGroup && Array.isArray(onRowAdd) ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>{renderInner()}</DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="max-w-64 min-w-auto">
              {onRowAdd.map(option => {
                return (
                  <DropdownMenuItem
                    key={option.id}
                    size="lg"
                    onSelect={() => option.onClick(groupId)}
                  >
                    {option.icon && (
                      <img className="self-start" src={option.icon} alt="" />
                    )}

                    <div className="flex flex-col gap-1">
                      {option.title && (
                        <h3 className="text-md font-semibold">
                          {option.title}
                        </h3>
                      )}
                      {option.description && (
                        <p className="text-md">{option.description}</p>
                      )}
                    </div>
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          renderInner()
        )}
      </div>
    </div>
  );
};

TableRowAdd.propTypes = {
  groupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isGroup: PropTypes.bool
};

export default TableRowAdd;
